<template>
    <sub-section title="Everything you want after tax" helpTitle="Everything you want after tax"
                 :helpText="HelpText.everythingYouWant()">
        <div class="test-scenarios row text-center d-flex justify-content-center">
            <div class="col-xl-3">
                <div class="icon mx-auto">
                    <composite-icon :icons="[ { icon: 'bi-circle', size: '3.5rem' }, { icon: 'bi-currency-pound', size: '2.2rem', top: '0.95rem', left: '0.63rem' } ]"></composite-icon>
                </div>
                <p v-html="incomeText"></p>
            </div>
            <div class="col-xl-3 offset-xl-1">
                <div class="icon mx-auto">
                    <i class="bi bi-percent mb-4"></i>
                </div>
                <p v-if="showInflationText">{{ inflationText }}</p>
            </div>
            <div class="col-xl-3 offset-xl-1">
                <div class="icon mx-auto">
                    <i class="bi bi-piggy-bank mb-4"></i>
                </div>
                <p v-html="monthlyPotsContributionText"></p>
            </div>
        </div>

        <div v-if="showIncomeAdjustorResetWarning" class="mt-4 mb-0 alert alert-success">
            <i class="bi bi-info-circle-fill me-2 fs-5"></i> As some of your inputs have changed we have reset the level of income
            wanted and removed any guaranteed income if you added any. Please
            solve again if there are now shortfalls and/or re-add guaranteed
            income if you want some.
        </div>
    </sub-section>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import SubSection from "@/guiide/components/common/SubSection.vue";
import HelpText from "@/guiide/ts/helpText";
import { formatter } from "@/shared/ts/formatter";
import { retireeDescriber } from "@/guiide/ts/retireeDescriber";
import CompositeIcon from "@/guiide/components/common/CompositeIcon.vue";

export default defineComponent({
  name: "EverythingYouWant",
  components: {
    SubSection,
    CompositeIcon
  },
  setup() {
    return {
      HelpText
    };
  },
  data() {
    return {
      showIncomeAdjustorResetWarning: false
    };
  },
  watch: {
    "$store.state.retiree.solution.incomeAdjustorReset"(
      incomeAdjustorReset: null | boolean
    ) {
      if (incomeAdjustorReset == null) {
        return false;
      }
      this.showIncomeAdjustorResetWarning = incomeAdjustorReset;
    }
  },
  computed: {
    incomeText: function (): string {
      return retireeDescriber.incomeStatement();
    },
    inflationText: function (): string {
      return retireeDescriber.inflationStatement();
    },
    showInflationText: function (): boolean {
      return this.inflationText.length > 0;
    },
    monthlyPotsContributionText: function (): string {
      if (this.$store.state.retiree == null) {
        return "";
      }

      const formattedContrib = formatter.formatCurrency(
        this.$store.state.retiree.monthlyPotsContribution
      );
      return `You are currently paying <b>${formattedContrib}</b> per month into your defined contribution pension pots.`;
    }
  }
});
</script>

<style scoped>
    .test-scenarios p {
        font-size: 1.2rem !important;
    }

    .icon > i {
        font-size: 3.5rem;
        color: #243b52;
    }
</style>
